<script setup lang="ts">
import { useFormField } from "#imports";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  id?: string;
}>();

const showPassword = ref(false);

const fallbackId = useId();
const { id: formFieldId, color, highlight, ariaAttrs } = useFormField(props);
const inputId = computed(() => props.id ?? formFieldId.value ?? fallbackId);

const attrs = useAttrs();
const forwardedAttrs = computed(() => {
  const { type: _type, ...rest } = attrs;
  return rest;
});
</script>

<template>
  <UInput
    :id="inputId"
    v-bind="{ ...forwardedAttrs, ...ariaAttrs }"
    :type="showPassword ? 'text' : 'password'"
    :color="color"
    :highlight="highlight"
    class="w-full"
  >
    <template #trailing>
      <UButton
        square
        color="neutral"
        variant="ghost"
        size="lg"
        class="p-1 text-blue-600 hover:text-blue-700"
        :icon="showPassword ? 'icon:hide' : 'icon:view'"
        :aria-label="showPassword ? $t('ui.password.hide') : $t('ui.password.show')"
        :aria-pressed="showPassword"
        :aria-controls="inputId"
        @click="() => { showPassword = !showPassword }"
      />
    </template>
  </UInput>
</template>
